var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3297 16.1499L13.8597 18.6199C12.4897 19.9899 12.4897 22.1999 13.8597 23.5699C15.2297 24.9399 17.4397 24.9399 18.8097 23.5699L22.6997 19.6799C25.4297 16.9499 25.4297 12.5099 22.6997 9.77992C19.9697 7.04992 15.5297 7.04992 12.7997 9.77992L8.55969 14.0199C6.21969 16.3599 6.21969 20.1599 8.55969 22.5099",
    stroke: "#9C9EA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/fileUpload.18ac7b8f37062d13217237e56c95af25.svg";
export { ForwardRef as ReactComponent };